import { SecurityMetadataV2 } from 'phoenix/stores/SecurityMetadataV2Store';

export const GetOffshoreReinvestmentType = (meta?: SecurityMetadataV2): 'cash' | 'reinvest' => {
    return meta?.mutualFund?.offshoreCashDividendsAvailable === true ? 'cash' : 'reinvest';
};
